import { render, staticRenderFns } from "./DashboardArticles.vue?vue&type=template&id=4b3dc38a&scoped=true&"
import script from "./DashboardArticles.vue?vue&type=script&lang=js&"
export * from "./DashboardArticles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b3dc38a",
  null
  
)

export default component.exports